import React, { useEffect } from "react";
import "./About.scss";
import { motion, useAnimate} from "framer-motion";

// Images.....
import AboutBgImg from "../../assets/images/aboutBg.png";
import AboutUsImg from "../../assets/images/aboutUsImg.png";
import DownArrowIcon from "../../assets/images/downArrowIcon.png";
import AboutDivider from "../../assets/images/AboutDivider.png";
import SliderImg1 from "../../assets/images/sliderImg2.png";
import SliderImg2 from "../../assets/images/sliderImg3.png";
import SliderImg3 from "../../assets/images/sliderImg5.png";
import SliderImg4 from "../../assets/images/sliderImg6.png";
import Upwealth1 from "../../assets/images/UPWEALTH1.png";
import Upwealth2 from "../../assets/images/UPWEALTH2.png";
import Upwealth3 from "../../assets/images/UPWEALTH3.png";

import flipCard1 from "../../assets/images/flipCard1.png";
import flipCard2 from "../../assets/images/flipCard2.png";
import flipCard3 from "../../assets/images/flipCard3.png";
import flipCard4 from "../../assets/images/flipCard4.png";

const About = () => {
  const [scope, animate] = useAnimate();

  const documentPresentWidth = window.innerWidth;


  // for cards X and Y position...

  const handleMouseEnter = async () => {
    // rotate the main-card
    animate("#mainCard", {
      rotateY: "-25deg",
    });
    // for transforming the cards...
    animate(".hidden__Card1", {
      x: documentPresentWidth > 1023 ? "-620%" : "-420%",
      y: "70%",
    });
    animate(".hidden__Card2", {
      // x: "-440%",
      x: documentPresentWidth > 1023 ? "-440%" : "-370%",
      y: "-100%",
    });
    animate(".hidden__Card3", {
      // x: "440%",
      x: documentPresentWidth > 1023 ? "440%" : "320%",
      y: "-100%",
    });
    await animate(".hidden__Card4", {
      x: documentPresentWidth > 1023 ? "620%" : "380%",
      y: "70%",
    });

    // for rotate the cards...
    animate(".hidden__Card1", { rotateZ: "5deg" });
    animate(".hidden__Card2", { rotateZ: "-10deg" });
    animate(".hidden__Card3", { rotateZ: "-10deg" });
    animate(".hidden__Card4", { rotateZ: "10deg" });
  };

  useEffect(()=>{
    const animationInterval = setTimeout(handleMouseEnter,7000);

    return()=>{
      clearTimeout(animationInterval);
    }
  },[])

  return (
    <>
      <div className="About__wrapper">
        <div className="About__mainWrapper">
          <motion.img
            initial={{
              opacity: 0,
              scale: 0,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 1.5,
              ease: "backOut",
              delay: 0.5,
            }}
            className="About__BgImg"
            src={AboutBgImg}
            alt="about__bgImg"
          />

          <motion.img
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.8, ease: "backOut" }}
            src={Upwealth1}
            alt="upwealth1-text"
            className="About__BgUpwealth1"
          />

          <motion.img
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.8, delay: 1.4, ease: "backOut" }}
            src={Upwealth2}
            alt="upwealth1-text"
            className="About__BgUpwealth2"
          />
          <motion.img
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 2.2, delay: 1.8, ease: "backOut" }}
            src={Upwealth3}
            alt="upwealth1-text"
            className="About__BgUpwealth3"
          />
          <div className="About__imageAndContentWrapper">
            <div ref={scope} className="About__imageWrapper">
              <motion.img
                id="mainCard"
                initial={{
                  scale: 100,
                  opacity: 0,
                }}
                whileInView={{
                  scale: 1,
                  opacity: 1,
                }}
                transition={{
                  duration: 0.8,
                  ease: "linear",
                }}
                viewport={{ once: true }}
                onMouseEnter={handleMouseEnter}
                src={AboutUsImg}
                alt="AboutBgImg"
              />

              <motion.div
                initial={{ rotateZ: "40deg" }}
                className="flip-card hidden__Card1"
              >
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <motion.img
                      src={SliderImg2}
                      alt="Avatar"
                      className=""
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div className="flip-card-back">
                    <motion.img
                      src={flipCard1}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ rotateZ: "40deg" }}
                className="flip-card hidden__Card2"
              >
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <motion.img
                      src={SliderImg3}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="flip-card-back">
                    <motion.img
                      src={flipCard2}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </motion.div>

              <motion.div
                className="flip-card hidden__Card3"
                initial={{ rotateZ: "-20deg" }}
              >
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <motion.img
                      src={SliderImg1}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="flip-card-back">
                    <motion.img
                      src={flipCard3}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ rotateZ: "-40deg" }}
                className="flip-card hidden__Card4"
              >
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <motion.img
                      src={SliderImg4}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="flip-card-back">
                    <motion.img
                      src={flipCard4}
                      alt="Avatar"
                      className=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </motion.div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "backOut", delay: 1 }}
              className="About__mainContentWrapper"
            >
              <div className="About__contentWrapper">
                <div className="About__titleAndSubtitleWrapper">
                  <div className="About__subTitleWrapper">
                    <h3>About us</h3>
                  </div>
                  <div className="About__titleAndSubSeprator" />
                  <div className="About__titleWrapper">
                    <h2>Grow your net worth by growing your network.</h2>
                  </div>
                </div>

                <div className="About__titleSperator">
                  <img src={AboutDivider} alt="about_dividerImg" />
                </div>

                <div className="About__shortInfoWrapper">
                  <p>
                    UpWealth magazine is a premier magazine for entrepreneurs by
                    entrepreneurs. Do you ever wonder how entrepreneurs become
                    debt-free and financially free while spending time with
                    their loved ones and doing the thing they enjoy? Well, look
                    no further. UPWealth has all the answers you need. Read from
                    small to large business owners who have mastered the art of
                    creating and maintaining business systems, sticking to their
                    visions and persisting in their missions!The power of
                    leveraging other businesses is unmatched.
                  </p>
                </div>
              </div>
              <a
                href="#newrelease"
                className="moveToNewSec__Btn"
                aria-description="move-to-the-next-section-button"
              >
                <img src={DownArrowIcon} alt="downArrowIcon" />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

{
  /* <div className="About__mainWrapper">
    
    <motion.img
      initial={{
        opacity: 0,
        scale: 0,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      transition={{
        duration: 1.5,
        ease: "backOut",
        delay: 0.5,
      }}
      className="About__BgImg"
      src={AboutBgImg}
      alt="about__bgImg"
    />
    <motion.img
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.4, delay: 1, ease: "backOut" }}
      src={Upwealth1}
      alt="upwealth1-text"
      className="About__BgUpwealth1"
    />
    <motion.img
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.6, delay: 1, ease: "backOut" }}
      src={Upwealth2}
      alt="upwealth1-text"
      className="About__BgUpwealth2"
    />
    <motion.img
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.8, delay: 1, ease: "backOut" }}
      src={Upwealth3}
      alt="upwealth1-text"
      className="About__BgUpwealth3"
    />
    <div className="About__contentMainWrapper">
      <div ref={scope} className="AboutUs__imgWrapper">
        <motion.img
          id="mainCard"
          initial={{
            scale: 100,
            opacity: 0,
          }}
          whileInView={{
            scale: 1,
            opacity: 1,
          }}
          transition={{
            duration: 0.8,
            ease: "linear",
          }}
          viewport={{ once: true }}
          onMouseEnter={handleMouseEnter}
          src={AboutUsImg}
          alt="AboutBgImg"
        />

        <motion.div
          initial={{ rotateZ: "40deg" }}
          className="flip-card hidden__Card1"
        >
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <motion.img
                src={SliderImg2}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className="flip-card-back">
              <motion.img
                src={flipCard1}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
          </div>
        </motion.div>



        <motion.div
          initial={{ rotateZ: "40deg" }}
          className="flip-card hidden__Card2"
        >
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <motion.img
                src={SliderImg3}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
            <div className="flip-card-back">
              <motion.img
                src={flipCard2}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
          </div>
        </motion.div>

        


        <motion.div
          className="flip-card hidden__Card3"
          initial={{ rotateZ: "-20deg" }}
        >
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <motion.img
                src={SliderImg1}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
            <div className="flip-card-back">
              <motion.img
                src={flipCard3}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
          </div>
        </motion.div>

      

       

        <motion.div initial={{ rotateZ: "-40deg" }}  className="flip-card hidden__Card4">
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <motion.img
                src={SliderImg4}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
            <div className="flip-card-back">
              <motion.img
                src={flipCard4}
                alt="Avatar"
                className=""
                style={{ width: "100%", height: "100%",objectFit:'cover' }}
              />
            </div>
          </div>
        </motion.div>

     
      </div>
      <motion.div
        initial={{
          y: 100,
          opacity: 0,
        }}
        whileInView={{
          y: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.9,
          ease: "easeInOut",
        }}
        className="About__contextMainWrapper"
      >
        <div className="About__contentWrapper">
          <div className="About__contentLeftWrapper">
            <h3>About us</h3>
            <h2>Grow your net worth by growing your network.</h2>
            <img src={AboutDivider} alt="about_dividerImg" />
          </div>
          <div className="About__contentRightWrapper">
            <p>
              UpWealth magazine is a premier magazine for entrepreneurs by
              entrepreneurs. Do you ever wonder how entrepreneurs become
              debt-free and financially free while spending time with their
              loved ones and doing the thing they enjoy? Well, look no
              further. UPWealth has all the answers you need. Read from small
              to large business owners who have mastered the art of creating
              and maintaining business systems, sticking to their visions and
              persisting in their missions!The power of leveraging other
              businesses is unmatched.
            </p>
          </div>
        </div>
        <button
          className="moveToNewSec__Btn"
          aria-description="move-to-the-next-section-button"
        >
          <img src={DownArrowIcon} alt="downArrowIcon" />
        </button>
      </motion.div>
    </div>
  </div> */
}
